import React, { TextField, Grid, Paper, Autocomplete, Button } from '@mui/material';
import { Collapser } from 'components';
import { PartnerFilterPaneProps } from './PartnerFilterPaneProps';
import { useState } from 'react';
import { usePartners } from 'hooks';

export const PartnerFilterPane = ({ filterData, setFilterData }: PartnerFilterPaneProps) => {
	const [isExpanded, setIsExpanded] = useState(false);
	const { partners } = usePartners();
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	const handleFilterChange = (event: any) => {
		setFilterData({ ...filterData, [event.target.name]: event.target.value });
	};
	return (
		<Paper sx={{ p: 5 }}>
			<Grid container spacing={3}>
				<Grid item xs={12}>
					<Grid container spacing={2} alignItems='center'>
						<Grid item xs={11}>
							<TextField size='small' label='Email' fullWidth name='email' value={filterData.email} onChange={handleFilterChange} />
						</Grid>
						<Grid item xs={1} textAlign={'center'} alignSelf={'end'}>
							<Button onClick={() => setIsExpanded(!isExpanded)}>
								<Collapser isAdd={false} open={isExpanded} />
							</Button>
						</Grid>
					</Grid>
				</Grid>
				{isExpanded && (
					<>
						{
							<>
								<Grid item xs={12}>
									<Grid container>
										<Grid item xs={12}>
											<Autocomplete
												options={partners || []}
												getOptionLabel={option => option.firstName + ' ' + option.lastName}
												value={partners?.find(partner => partner.id === filterData.mentorId) ?? null}
												onChange={(_, value) => setFilterData({ ...filterData, mentorId: value?.id ?? 0 })}
												renderInput={params => <TextField {...params} label='Partner' size='small' />}
											/>
										</Grid>
									</Grid>
								</Grid>
								<Grid item xs={6}>
									<TextField fullWidth size='small' name='firstName' label='First name' value={filterData.firstName} onChange={handleFilterChange} />
								</Grid>

								<Grid item xs={6}>
									<TextField fullWidth size='small' name='lastName' label='Last name' value={filterData.lastName} onChange={handleFilterChange} />
								</Grid>

								<Grid item xs={12}>
									<TextField fullWidth size='small' name='address' label='Address' value={filterData.address} onChange={handleFilterChange} />
								</Grid>

								<Grid item xs={6}>
									<TextField fullWidth size='small' label='Zip code' name='zipCode' value={filterData.zipCode} onChange={handleFilterChange} />
								</Grid>

								<Grid item xs={6}>
									<TextField fullWidth size='small' name='city' label='City' value={filterData.city} onChange={handleFilterChange} />
								</Grid>
							</>
						}
					</>
				)}
			</Grid>
		</Paper>
	);
}